import { GraphQLError } from "graphql";

import ERRORS from "../Errors";

const translateErrors = (graphQLErrors: readonly GraphQLError[] | any) => {
  if (typeof graphQLErrors !== "object")
    return "เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ";
  
  const errorArray = [];
  for (const graphQLError of graphQLErrors) {
    try {
      const errorCode = graphQLError.extensions?.ERROR_CODE as string;
      if (ERRORS[errorCode] === undefined) {
        return "เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ";
      }
      errorArray.push(ERRORS[errorCode]);
    } catch {
      return "เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ";
    }
  }
  if (errorArray.length < 1) return "เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ";
  return errorArray.join(", ");
};

export default translateErrors;
